<template>
  <section id="skills" class="mb-44 md:mb-0">
    <div class="h-screen">
      <div class="h-full flex flex-col justify-center">
        <div class="text-center mb-10 -mt-36 exp">
          <p>***</p>
          <p
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-duration="1000"
            data-aos-easing="ease-in-sine"
            class="scroll__sub__headers font-bold"
          >
            My Skills
          </p>
        </div>
        <div
          class="
            px-8
            md:px-32
            lg:px-52
            xl:px-0
            grid
            lg:grid-cols-2
            place-item-center
            xl:grid-cols-4
            gap-x-5 gap-y-3
          "
        >
          <!-- frontend -->
          <div
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-anchor-placement="bottom-bottom"
            :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
            class="xl:col-start-2 scroll_3_boxes p-8 rounded-lg"
          >
            <div>
              <p class="font-bold exp text-center">Frontend</p>
              <div class="grid grid-cols-2 gap-3 mt-5">
                <div class="flex items-center">
                  <svg
                    class="w-3 h-3 md:w-6 md:h-6 exp"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <p
                    :class="[
                      $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                    ]"
                    class="pl-2 text-xs md:text-base lg:text-sm xl:text-base"
                  >
                    HTML
                  </p>
                </div>
                <div class="flex items-center">
                  <svg
                    class="w-3 h-3 md:w-6 md:h-6 exp"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <p
                    :class="[
                      $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                    ]"
                    class="pl-2 text-xs md:text-base lg:text-sm xl:text-base"
                  >
                    CSS
                  </p>
                </div>
                <div class="flex items-center">
                  <svg
                    class="w-3 h-3 md:w-6 md:h-6 exp"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <p
                    :class="[
                      $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                    ]"
                    class="pl-2 text-xs md:text-base lg:text-sm xl:text-base"
                  >
                    Bootstrap
                  </p>
                </div>
                <div class="flex items-center">
                  <svg
                    class="w-3 h-3 md:w-6 md:h-6 exp"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <p
                    :class="[
                      $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                    ]"
                    class="pl-2 text-xs md:text-base lg:text-sm xl:text-base"
                  >
                    Tailwindcss
                  </p>
                </div>
                <div class="flex items-center">
                  <svg
                    class="w-3 h-3 md:w-6 md:h-6 exp"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <p
                    :class="[
                      $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                    ]"
                    class="pl-2 text-xs md:text-base lg:text-sm xl:text-base"
                  >
                    JavaScript
                  </p>
                </div>
                <div class="flex items-center">
                  <svg
                    class="w-3 h-3 md:w-6 md:h-6 exp"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <p
                    :class="[
                      $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                    ]"
                    class="pl-2 text-xs md:text-base lg:text-sm xl:text-base"
                  >
                    Vue
                  </p>
                </div>
                <div class="flex items-start">
                  <svg
                    class="w-3 h-3 md:w-6 md:h-6 exp"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <div class="flex flex-col justify-center items-center">
                    <p
                      :class="[
                        $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                      ]"
                      class="pl-2 text-xs md:text-base lg:text-sm xl:text-base"
                    >
                      React
                    </p>
                    <small class="text-gray-400 text-xs">basic</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- backend -->
          <div
            data-aos="fade-up"
            data-aos-duration="2000"
            data-aos-offset="100"
            data-aos-anchor-placement="bottom-bottom"
            :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
            class="scroll_3_boxes p-8 rounded-lg"
          >
            <div>
              <p class="font-bold exp text-center">Backend</p>
              <div class="grid grid-cols-2 gap-3 mt-5">
                <div class="flex items-center">
                  <svg
                    class="w-3 h-3 md:w-6 md:h-6 exp"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <p
                    :class="[
                      $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                    ]"
                    class="pl-2 text-xs md:text-base lg:text-sm xl:text-base"
                  >
                    PHP
                  </p>
                </div>
                <div class="flex items-center">
                  <svg
                    class="w-3 h-3 md:w-6 md:h-6 exp"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <p
                    :class="[
                      $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                    ]"
                    class="pl-2 text-xs md:text-base lg:text-sm xl:text-base"
                  >
                    Laravel
                  </p>
                </div>
                <div class="flex items-center">
                  <svg
                    class="w-3 h-3 md:w-6 md:h-6 exp"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <p
                    :class="[
                      $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                    ]"
                    class="pl-2 text-xs md:text-base lg:text-sm xl:text-base"
                  >
                    Mysql
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
</style>